var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line"},_vm._l((_vm.parts),function(part){return _c(_vm.getPartName(part),{key:part.type,tag:"component",attrs:{"data":part,"is-argb":_vm.isArgb}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }